export default __webpack_public_path__ + "static/media/lessonBK.aacba8fb.png";